import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dynamicContent', 'missionBox']
  static values = {
    texts: Array,
    interval: { type: Number, default: 4000 }
  }

  connect() {
    this.currentIndex = 0
    this.textIndex = 0
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.1
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.intervalId) clearInterval(this.intervalId)
    if (this.observer) this.observer.disconnect()
  }

  handleIntersect(entries) {
    const entry = entries[0]
    if (entry.isIntersecting) {
      if (!this.intervalId) this.startRotation()
    } else {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    }
  }

  startRotation() {
    this.intervalId = setInterval(() => {
      this.rotateMissionBox()
      this.rotateContent()
    }, this.intervalValue)
  }

  rotateContent() {
    const current = this.dynamicContentTargets[this.currentIndex]
    if (!current) return;

    current.classList.remove('opacity-100')
    current.classList.add('opacity-0')

    this.currentIndex = (this.currentIndex + 1) % this.dynamicContentTargets.length

    const next = this.dynamicContentTargets[this.currentIndex]
    setTimeout(() => {
      next.classList.add('opacity-100')
      next.classList.remove('opacity-0')
    }, 10)
  }

  rotateMissionBox() {
    if (this.missionBoxTargets.length < 1) return;

    const current = this.missionBoxTargets[this.currentIndex]
    if (!current) return;

    current.classList.remove('md:border-ih-blue', 'md:bg-ih-purple-5')
    current.classList.add('md:border-ih-purple-20', 'md:bg-white')

    const next = this.missionBoxTargets[(this.currentIndex + 1) % this.missionBoxTargets.length]
    setTimeout(() => {
      next.classList.add('md:border-ih-blue', 'md:bg-ih-purple-5')
      next.classList.remove('md:border-ih-purple-20', 'md:bg-white')
    }, 10)
  }

  selectIndex = (e) => {
    const currentImg = this.dynamicContentTargets[this.currentIndex]
    const currentMissionBox = this.missionBoxTargets[this.currentIndex]
    if (!currentImg) return;

    currentImg.classList.remove('opacity-100')
    currentImg.classList.add('opacity-0')
    currentMissionBox.classList.remove('md:border-ih-blue', 'md:bg-ih-purple-5')
    currentMissionBox.classList.add('md:border-ih-purple-20', 'md:bg-white')

    this.currentIndex = Number(e.currentTarget.dataset.indexNumber);

    const nextImg = this.dynamicContentTargets[this.currentIndex]
    const nextMissionBox = this.missionBoxTargets[this.currentIndex]
    setTimeout(() => {
      nextImg.classList.add('opacity-100')
      nextImg.classList.remove('opacity-0')
      nextMissionBox.classList.add('md:border-ih-blue', 'md:bg-ih-purple-5')
      nextMissionBox.classList.remove('md:border-ih-purple-20', 'md:bg-white')
    }, 10)

    if (this.intervalId) clearInterval(this.intervalId)
  }
}
